import { createSlice } from '@reduxjs/toolkit';

export type Question = {
  question: string;
  _id: string;
};

export type Checklist = {
  name: string;
  _id: string;
  data: Question[];
};

export type CheckListLibrary = {
  checklists: Checklist[];
  email: string;
  name: string;
  updated_at: string;
  userId: string;
  _id: string;
};

export interface ChecklistInitialStates {
  checklists: Checklist[];
}

const initialState: ChecklistInitialStates = {
  checklists: [],
};

const checklistSlice = createSlice({
  name: 'projectSlice',
  initialState,
  reducers: {
    saveChecklists: (state, { payload }) => {
      state.checklists = payload;
    },
  },
});

export const { saveChecklists } = checklistSlice.actions;
export default checklistSlice.reducer;
